import "@/App.css";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ProductsSection from "@/components/ProductsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import PartnersSection from "@/components/PartnersSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import { PRODUCTS, TESTIMONIALS, PARTNERS, COMPANY_INFO } from "@/data/staticData";

function App() {
  return (
    <div className="min-h-screen bg-[#EDE9E1]" data-testid="app-container">
      <Navbar />
      <main>
        <HeroSection companyInfo={COMPANY_INFO} />
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <hr className="border-[#BEBEBD]/40" />
        </div>
        <ProductsSection products={PRODUCTS} />
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <hr className="border-[#BEBEBD]/40" />
        </div>
        <PartnersSection partners={PARTNERS} />
        {/* <TestimonialsSection testimonials={TESTIMONIALS} /> */}
        {/* <div className="max-w-7xl mx-auto px-6 md:px-12">
          <hr className="border-[#BEBEBD]/40" />
        </div> */}
        <ContactSection />
      </main>
      <Footer />

      {/* JSON-LD Structured Data for SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Divya Enterprises",
            description:
              "Leading manufacturer of stainless steel yarn conditioning trolleys and ultra high molecular pure castor wheels",
            telephone: "+91-9911414981",
            address: {
              "@type": "PostalAddress",
              addressLocality: "New Delhi",
              addressCountry: "IN",
            },
            foundingDate: "1999",
            numberOfEmployees: { "@type": "QuantitativeValue", value: "50+" },
          }),
        }}
      />
    </div>
  );
}

export default App;
